import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Solution } from './components/Solution';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Benefits } from './components/Benefits';
import { PremiumProduct } from './components/PremiumProduct';
import { PremiumBonuses } from './components/PremiumBonuses';
import { PricingOptions } from './components/PricingOptions';
import { Objections } from './components/Objections';
import { Testimonials } from './components/Testimonials';
import { Urgency } from './components/Urgency';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1100702405600602');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1100702405600602&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-white font-sans text-brand-text selection:bg-brand-gold/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Identification data-id="element-2" />
      <Solution data-id="element-3" />
      <Product data-id="element-4" />
      <Bonuses data-id="element-5" />
      <ValueStack data-id="element-6" />
      <Benefits data-id="element-7" />
      <PremiumProduct data-id="element-8" />
      <PremiumBonuses data-id="element-9" />
      <PricingOptions data-id="element-10" />
      <Objections data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Urgency data-id="element-13" />
      <Closing data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}